import { createSelector } from 'reselect'

const selectVideo = state => state.videos

const selectVideos = createSelector(
  selectVideo,
  videos => videos.videos
)

const selectVideosFetching = createSelector(
  selectVideo,
  videos => videos.isFetching
)

const selectCurrentPhoneVideoId = createSelector(
  selectVideo,
  videos => videos.currentPhoneId
)

export { selectVideos, selectVideosFetching, selectCurrentPhoneVideoId }



// WEBPACK FOOTER //
// ./src/containers/Videos/selectors.js